/**
 * @owner @Appboy/core-objects
 */
export const customObjectsOnboardingStatus = "/custom_objects/onboarding_status" as const;
